export default __webpack_public_path__ + "static/media/trailers_banner.651fbc17.jpg";